import React from "react";
import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";

export default function CheckoutCancelPage() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-radial-neon text-white flex flex-col">
      <div className="max-w-3xl w-full mx-auto px-4 sm:px-6 py-10 flex-1 flex flex-col">
        <Logo to="/" />
        <div
          className="mt-12 mx-auto w-full max-w-md rounded-3xl border border-white/10 bg-zinc-950/70 backdrop-blur-sm p-8 text-center"
          data-testid="checkout-cancel-card"
        >
          <XCircle className="mx-auto text-zinc-500" size={36} />
          <h1
            className="mt-5 font-display text-2xl font-black"
            data-testid="checkout-cancel-title"
          >
            {t("cancel.title") || "Zahlung abgebrochen"}
          </h1>
          <p className="mt-2 text-sm text-zinc-400">
            {t("cancel.sub") ||
              "Kein Problem — du wurdest nicht belastet. Schau dir die Premium-Vorteile in Ruhe an und starte später, wenn du soweit bist."}
          </p>
          <div className="mt-7 flex flex-col gap-2">
            <Button
              asChild
              className="rounded-full bg-neon text-black hover:bg-neon-hover font-bold shadow-neon"
              data-testid="checkout-cancel-retry"
            >
              <Link to="/pricing">{t("cancel.retry") || "Premium ansehen"}</Link>
            </Button>
            <Button
              asChild
              variant="outline"
              className="rounded-full bg-transparent border-white/10 text-white hover:bg-white/5"
            >
              <Link to="/app">{t("cancel.go_dashboard") || "Zurück zum Dashboard"}</Link>
            </Button>
          </div>
        </div>
        <Footer variant="compact" />
      </div>
    </div>
  );
}
